import { Box } from "@mui/material";
import { PropsWithChildren } from "react";

export default function CenteredBox({children}: PropsWithChildren) {
  return (
    <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh" minWidth="100vw">
      {children}
    </Box>
  )
}